// Portal and auth routes that require an authenticated context.
// Used by multiple consumers (ClientProviders, PageTracker) to maintain a single source of truth.
export const PORTAL_PATH_PREFIXES = [
  "/admin",
  "/employee",
  "/hr",
  "/client",
  "/marketing-manager",
  "/marketing-executive",
  "/lead",
  "/auth",
];
